var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/Check_green_small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile/tablet-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-profile---edit-Copy-8",
    transform: "translate(-139.000000, -388.000000)",
    fill: "#43A047",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "survey",
    transform: "translate(11.000000, 197.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.557692,224.052885 L165.389423,204.221154 L162.269231,200.995192 L145.557692,217.759615 L137.730769,209.879808 L134.610577,213 L145.557692,224.052885 Z M150,191 C154.019251,191 157.738765,192.004798 161.158654,194.014423 C164.472773,195.918279 167.081721,198.527227 168.985577,201.841346 C170.995202,205.261235 172,208.980749 172,213 C172,217.019251 170.995202,220.738765 168.985577,224.158654 C167.081721,227.472773 164.472773,230.081721 161.158654,231.985577 C157.738765,233.995202 154.019251,235 150,235 C145.980749,235 142.261235,233.995202 138.841346,231.985577 C135.527227,230.046465 132.918279,227.419888 131.014423,224.105769 C129.004798,220.68588 128,216.983994 128,213 C128,209.016006 129.004798,205.31412 131.014423,201.894231 C132.953535,198.580112 135.580112,195.953535 138.894231,194.014423 C142.31412,192.004798 146.016006,191 150,191 Z",
    id: "Check_green_small"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkGreen);
export default __webpack_public_path__ + "static/media/checkmark_green.664c264823f1236fb54d7fd58cac6f2b.svg";
export { ForwardRef as ReactComponent };